<script setup lang="ts">

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
       preserveAspectRatio="xMidYMid meet">
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
       class="tw-fill-namaGray dark:tw-fill-white" stroke="none">
      <path
        d="M545 4033 c-78 -41 -115 -103 -115 -193 0 -89 37 -152 112 -191 36 -18 91 -19 2018 -19 1927 0 1982 1 2018 19 75 39 112 101 112 191 0 66 -16 107 -59 153 -56 61 87 57 -2075 57 -1786 -1 -1984 -2 -2011 -17z"/>
      <path
        d="M1185 2753 c-78 -41 -115 -103 -115 -193 0 -89 37 -152 112 -191 36 -18 80 -19 1378 -19 1298 0 1342 1 1378 19 75 39 112 101 112 191 0 66 -16 107 -59 153 -55 60 27 57 -1435 57 -1203 -1 -1344 -2 -1371 -17z"/>
      <path
        d="M1825 1473 c-78 -41 -115 -103 -115 -193 0 -89 37 -152 112 -191 36 -18 69 -19 738 -19 669 0 702 1 738 19 75 39 112 101 112 191 0 66 -16 107 -59 153 -54 59 -31 57 -795 57 -619 -1 -704 -3 -731 -17z"/>
    </g>
  </svg>
</template>

<style scoped>

</style>
